import { useState, useEffect, useCallback } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";

export function useWebhooks() {
  const [webhooks, setWebhooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { user } = useAuth();

  // Admin sees all webhooks (companyId = "sound-admin"), partner sees own
  const companyId = user?.companyId;

  const fetchWebhooks = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    setError(null);

    try {
      const res = await makeApiRequest(
        "get",
        apiRoutes.getWebhooks,
        { id: user.id, accessToken: user.accessToken },
        companyId
      );
      setWebhooks(res.data?.data ?? res.data ?? []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [companyId, user?.id, user?.accessToken]);

  useEffect(() => {
    fetchWebhooks();
  }, [fetchWebhooks]);

  return { webhooks, loading, error, refetch: fetchWebhooks };
}
